import { useState } from "react";
import styled from "styled-components/macro";
import { useSkipioApi } from "../../api";
import { Box, BoxContent, BoxHeader, BoxTitle } from "../Box";
import Button from "../Button";
import Input, { Label } from "../Input";
import Stack from "../Stack";
import { useFields } from "../../hooks/use-fields";
import timezoneOptions from "../../util/timezoneOptions";
import RequestPhoneNumberInput, {
  usePurchasePhoneNumber,
} from "./RequestPhoneNumberInput";

export default function AccountSetup({ onComplete }) {
  const skipioApi = useSkipioApi();
  const [errors, setErrors] = useState({});
  const { field, value } = useFields({
    initialValue: {
      apiPhoneNumber: {
        apiPhoneProvider: "twilio",
        apiPhoneNumber: "",
      },
      timezone: "",
      lang: "en",
    },
  });

  const purchasePhoneNumber = usePurchasePhoneNumber();

  const setupAccount = async (e) => {
    if (e) e.preventDefault();

    setErrors({});

    await skipioApi.userProfile.put(
      {},
      {
        data: {
          user: {
            timeZone: value.timezone,
            language: value.lang,
          },
        },
      }
    );

    const {
      apiPhoneNumber: { apiPhoneProvider, apiPhoneNumber },
    } = value;

    try {
      await purchasePhoneNumber({ apiPhoneProvider, apiPhoneNumber });
    } catch (_) {
      // @TODO is this the only error we know about?
      setErrors({ apiPhoneNumber: "This number has been taken" });
      return;
    }

    await onComplete();
  };

  return (
    <SignupBox elevated style={{ height: "100%" }}>
      <BoxHeader white>
        <BoxTitle>Pick Your Skipio Number</BoxTitle>
      </BoxHeader>
      <BoxContent>
        <Stack>
          <>
            <Label>This will be the number from which your messages send</Label>
            <RequestPhoneNumberInput
              {...field("apiPhoneNumber")}
              errors={errors["apiPhoneNumber"]}
            />
          </>

          <Input
            label="Timezone"
            required
            placeholder="timezone"
            {...field("timezone")}
            type="select"
          >
            <option value=""></option>
            {timezoneOptions}
          </Input>
          <Input label="Language" {...field("lang")} type="select">
            <option value="en">English</option>
            <option value="es">Español</option>
          </Input>
          <Center>
            <Button
              onClick={setupAccount}
              disabled={
                !(value.apiPhoneNumber?.apiPhoneNumber && value.timezone)
              }
            >
              Continue
            </Button>
          </Center>
        </Stack>
      </BoxContent>
    </SignupBox>
  );
}

const SignupBox = styled(Box)`
  ${BoxContent} {
    overflow: unset;
  }
  overflow-y: auto;
  ${BoxHeader} {
    height: auto;
    flex-shrink: 0;
  }
  @media (max-width: 1000px) {
    width: 100%;
    height: 100%;
    border: 0;
    max-width: unset;
  }
`;

const Center = styled.div`
  text-align: center;
`;
